import { useState, useCallback, useEffect } from 'react';

export type UseScroll = (position: number) => {
  isScroll: boolean;
};

export const useScroll: UseScroll = (position) => {
  const [isScroll, setIsScroll] = useState(false);

  const scrollHandler = useCallback(() => {
    setIsScroll(window.scrollY >= position);
  }, [position]);
  
  useEffect(() => {
    scrollHandler();
    window.addEventListener('scroll', scrollHandler);

    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, [scrollHandler]);

  return {
    isScroll,
  };
};
